import React from "react";
import { Provider } from "react-redux";
import { StoreContext } from "redux-react-hook";
import { ConnectedRouter } from "connected-react-router";
import { CookiesProvider } from "react-cookie";
import Keycloak from "keycloak-js";
import { KeycloakProvider } from "react-keycloak";
import configureStore, { browserHistory } from "./store/configureStore";
import ScreenLoading from "./components/general/ScreenLoading";
import ContainerWrapper from "./containers/ContainerWrapper";

const store = configureStore();

const keycloakOptions = {
  url: "https://auth.redhat.com/auth/",
  clientId: "lifecycle-management",
  realm: "EmployeeIDP",
  "always-refresh-token": true,
};

const initConfig = {
  onLoad: "check-sso",
  idToken:
    (localStorage.getItem("idToken") !== "undefined" &&
      localStorage.getItem("idToken")) ||
    null,
  token:
    (localStorage.getItem("token") !== "undefined" &&
      localStorage.getItem("token")) ||
    null,
  refreshToken:
    (localStorage.getItem("refreshToken") !== "undefined" &&
      localStorage.getItem("refreshToken")) ||
    null,
};

const keycloak = Keycloak(keycloakOptions);

const onKeycloakTokens = (tokens) => {
  tokens["idToken"] && localStorage.setItem("idToken", tokens["idToken"]);
  tokens["refreshToken"] &&
    localStorage.setItem("refreshToken", tokens["refreshToken"]);
  tokens["token"] && localStorage.setItem("token", tokens["token"]);
};

const onEvent = (event, error) => {
  // console.log("KeyCloak Event: ", event);
  if (event === "onReady") {
    if (!keycloak.authenticated) {
      keycloak.login();
    }

    if (keycloak.isTokenExpired(60)) {
      // console.log("Token will be expired in 60 seconds, update");
      keycloak.updateToken(60);
    }
  }

  if (event === "onAuthRefreshError") {
    if (!keycloak.authenticated) {
      keycloak.login();
    }
  }

  if (event === "onAuthRefreshSuccess" || event === "onAuthSuccess") {
    localStorage.setItem("idToken", keycloak.idToken || "");
    localStorage.setItem("refreshToken", keycloak.refreshToken || "");
    localStorage.setItem("token", keycloak.token || "");
  }

  if (event === "onTokenExpired") {
    // console.log("Token will be expired expired on " + new Date());
    keycloak
      .updateToken(60)
      .then((refreshed) => {
        if (refreshed) {
          console.log("Token was successfully refreshed");
        } else {
          console.log("Token is still valid");
        }
      })
      .catch(() => {
        console.log("Failed to refresh the token, or the session has expired");
      });
  }
};

const App = () => {
  return (
    <KeycloakProvider
      initConfig={initConfig}
      keycloak={keycloak}
      onTokens={onKeycloakTokens}
      onEvent={onEvent}
      LoadingComponent={<ScreenLoading />}
    >
      <StoreContext.Provider value={store}>
        <Provider store={store}>
          <ConnectedRouter history={browserHistory}>
            <CookiesProvider>
              <ContainerWrapper />
            </CookiesProvider>
          </ConnectedRouter>
        </Provider>
      </StoreContext.Provider>
    </KeycloakProvider>
  );
};

export default App;
